import { Breadcrumbs as BreadCrumbsMantine } from '@mantine/core';
import cs from 'classnames';
import Link from 'next/link';
import type { FC } from 'react';
import type { IBreadcrumbItemProps, IBreadcrumbsProps } from '@/DesignSystem/Model/DataModel';
const BreadcrumbItem: FC<IBreadcrumbItemProps> = ({
  href,
  title,
  icon,
  isActive
}) => {
  const Component = href ? Link : 'span';
  return <li className={cs('inline-flex items-center text-blueFive ml-2 after:mr-2 whitespace-nowrap first:mr-4 md:first:mr-0 md:last:ml-0 last:ml-4', !isActive && 'after:content-["/"]')} data-sentry-component="BreadcrumbItem" data-sentry-source-file="Breadcrumbs.tsx">
      <Component href={href as string} className={cs('text-sm md:text-base inline-flex items-center', isActive ? 'font-bold' : ' hover:blueFour ')} data-sentry-element="Component" data-sentry-source-file="Breadcrumbs.tsx">
        {icon}
        {title}
      </Component>
    </li>;
};
const Breadcrumbs: FC<IBreadcrumbsProps> = ({
  items,
  className
}) => {
  return <BreadCrumbsMantine className={cs('overflow-auto flex-nowrap py-3', className)} separator={null} separatorMargin={0} data-sentry-element="BreadCrumbsMantine" data-sentry-component="Breadcrumbs" data-sentry-source-file="Breadcrumbs.tsx">
      {items.map(({
      key,
      ...item
    }, index) => <BreadcrumbItem key={key} isActive={index === items.length - 1} {...item} />)}
    </BreadCrumbsMantine>;
};
export default Breadcrumbs;